import React, { useEffect, useState } from "react";
import { authFetch } from "../../utils/Security/authFetch"; // your custom fetch wrapper
import config from "../../config";

// Person interface
interface ResponsiblePerson {
  id: number;
  name: string;
  email: string;
  roleId: number;
}

// Role interface matching backend response
interface ResponsibleRole {
  roleId: number;
  roleName: string;
}

const ResponsiblePersonsManagement: React.FC = () => {
  const [persons, setPersons] = useState<ResponsiblePerson[]>([]);
  const [roles, setRoles] = useState<ResponsibleRole[]>([]);
  const [newPerson, setNewPerson] = useState<Omit<ResponsiblePerson, "id">>({
    name: "",
    email: "",
    roleId: 0,
  });
  const [editPerson, setEditPerson] = useState<ResponsiblePerson | null>(null);

  const API_BASE = "/api";

  // Fetch all persons
  const fetchPersons = async () => {
    const response = await authFetch(
      `${config.apiBaseUrl}${API_BASE}/persons`,
      { method: "GET", headers: { "Cache-Control": "no-cache" } }
    );
    const data = await response.json();
    setPersons(data);

    console.log("ss", data);
  };

  // Fetch all roles
  const fetchRoles = async () => {
    const response = await authFetch(`${config.apiBaseUrl}${API_BASE}/roles`, {
      method: "GET",
    });
    const data = await response.json();
    setRoles(data);

    console.log(data);
  };

  useEffect(() => {
    fetchPersons();
    fetchRoles();
  }, []);

  // Add person
  const handleAdd = async () => {
    if (!newPerson.name || !newPerson.email || newPerson.roleId === 0) return;

    await authFetch(`${config.apiBaseUrl}${API_BASE}/persons`, {
      method: "POST",
      body: JSON.stringify(newPerson),
      headers: { "Content-Type": "application/json" },
    });

    setNewPerson({ name: "", email: "", roleId: 0 });
    fetchPersons();
  };

  // Edit person
  const handleEdit = (person: ResponsiblePerson) => setEditPerson(person);

  // Update person
  const handleUpdate = async () => {
    if (!editPerson) return;

    await authFetch(
      `${config.apiBaseUrl}${API_BASE}/persons/${editPerson.id}`,
      {
        method: "POST", // or PUT if backend uses PUT
        body: JSON.stringify(editPerson),
        headers: { "Content-Type": "application/json" },
      }
    );

    setEditPerson(null);
    fetchPersons();
  };

  // Delete person
  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this person?")) return;

    await authFetch(`${config.apiBaseUrl}${API_BASE}/persons/${id}`, {
      method: "DELETE",
    });

    fetchPersons();
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <h1 style={{ color: "#f97316" }}>Responsible Persons Management</h1>

      {/* Add Person */}
      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Name"
          value={newPerson.name}
          onChange={(e) => setNewPerson({ ...newPerson, name: e.target.value })}
          style={{
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            marginRight: "10px",
          }}
        />
        <input
          type="email"
          placeholder="Email"
          value={newPerson.email}
          onChange={(e) =>
            setNewPerson({ ...newPerson, email: e.target.value })
          }
          style={{
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            marginRight: "10px",
          }}
        />
        <select
          value={newPerson.roleId}
          onChange={(e) =>
            setNewPerson({ ...newPerson, roleId: Number(e.target.value) })
          }
          style={{
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            marginRight: "10px",
          }}
        >
          <option value={0}>Select Role</option>
          {roles.map((role) => (
            <option key={role.roleId} value={role.roleId}>
              {role.roleName}
            </option>
          ))}
        </select>
        <button
          onClick={handleAdd}
          style={{
            backgroundColor: "#f97316",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Add Person
        </button>
      </div>

      {/* Edit Person */}
      {editPerson && (
        <div style={{ marginBottom: "20px" }}>
          <input
            type="text"
            value={editPerson.name}
            onChange={(e) =>
              setEditPerson({ ...editPerson, name: e.target.value })
            }
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginRight: "10px",
            }}
          />
          <input
            type="email"
            value={editPerson.email}
            onChange={(e) =>
              setEditPerson({ ...editPerson, email: e.target.value })
            }
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginRight: "10px",
            }}
          />
          <select
            value={editPerson.roleId}
            onChange={(e) =>
              setEditPerson({ ...editPerson, roleId: Number(e.target.value) })
            }
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginRight: "10px",
            }}
          >
            <option value={0}>Select Role</option>
            {roles.map((role) => (
              <option key={role.roleId} value={role.roleId}>
                {role.roleName}
              </option>
            ))}
          </select>
          <button
            onClick={handleUpdate}
            style={{
              backgroundColor: "#16a34a",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "8px",
              cursor: "pointer",
              marginRight: "5px",
            }}
          >
            Save
          </button>
          <button
            onClick={() => setEditPerson(null)}
            style={{
              backgroundColor: "#dc2626",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      )}

      {/* Persons Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          backgroundColor: "white",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <thead style={{ backgroundColor: "#f97316", color: "white" }}>
          <tr>
            <th style={{ padding: "12px", textAlign: "left" }}>ID</th>
            <th style={{ padding: "12px", textAlign: "left" }}>Name</th>
            <th style={{ padding: "12px", textAlign: "left" }}>Email</th>
            <th style={{ padding: "12px", textAlign: "left" }}>Role</th>
            <th style={{ padding: "12px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {persons.map((p) => {
            const role = roles.find((r) => r.roleId === p.roleId);
            return (
              <tr key={p.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>{p.id}</td>
                <td style={{ padding: "12px" }}>{p.name}</td>
                <td style={{ padding: "12px" }}>{p.email}</td>
                <td style={{ padding: "12px" }}>
                  {role ? role.roleName : "N/A"}
                </td>
                <td style={{ padding: "12px", textAlign: "center" }}>
                  <button
                    onClick={() => handleEdit(p)}
                    style={{
                      backgroundColor: "#3b82f6",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      marginRight: "8px",
                    }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(p.id)}
                    style={{
                      backgroundColor: "#dc2626",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
          {persons.length === 0 && (
            <tr>
              <td colSpan={5} style={{ padding: "20px", textAlign: "center" }}>
                No persons found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ResponsiblePersonsManagement;
